import { feature as smartBannersFlowFeature } from '@central-products/smart-banners-flow';

export const smartBannersFlowPlugin = {
  beforeBootstrap({ addBootstrapperFeature, params }) {
    addBootstrapperFeature(smartBannersFlowFeature, params);
  },
};
